import { StatusInterface } from "../StatusInterface";
import { Status } from "../Status";
import Translator from "../../../../../Translation/Translator";

class NotVerified extends Status implements StatusInterface  {

  public static statusId: number = 2;

  public getName(): string {
    return Translator.trans("status-not-verified");
  }

}

export { NotVerified }
